export const warningListRoutes = {
  path: '',
  name: 'WarningHistory',
  component: () => import('@/views/warningHistory/index.vue'),
  meta: {
    hidden: false,
    title: 'Warning History List'
  }
}



